import { usePolygonStore } from '../../../../../state-library/src'
import {
  EHeatMapCategory,
  IPolygonProperties,
} from '../../../../../types-library/src'
import {
  numberAsPercentage,
  numberWithCommaWithoutDecimals,
} from '../../../utils'
import { useEffect, useMemo, useState } from 'react'
import { MdTrendingUp } from 'react-icons/md'

interface Props {
  polygon: IPolygonProperties
  level: 'state' | 'municipality' | 'neighborhood' | 'block' | 'property'
  onMouseLeave: () => void
}

const PolygonPopupContent = ({
  polygon,
  level,
  onMouseLeave,
}: Props): JSX.Element => {
  const { heatMapCategory } = usePolygonStore()

  const [prices, setPrices] = useState<
    { id: string; name: string; value: string }[]
  >([])

  const name = useMemo(() => {
    if (level === 'property') {
      return 'Propiedad'
    }

    if (!polygon.name) {
      return 'Información'
    }

    if (level === 'block') {
      return `Mzn. ${polygon.name}`
    }

    return polygon.name
  }, [polygon])

  useEffect(() => {
    switch (heatMapCategory) {
      case EHeatMapCategory.PRICE:
        setPrices([
          {
            id: 'pricePerM2',
            name: 'Precio por m2',
            value:
              polygon?.priceAvgSqm > 1
                ? `$ ${numberWithCommaWithoutDecimals(polygon.priceAvgSqm)} mxn`
                : 'Sin estimado',
          },
          {
            id: 'averagePrice',
            name: 'Precio promedio por propiedad',
            value:
              polygon?.priceAvg > 1
                ? `$ ${numberWithCommaWithoutDecimals(polygon.priceAvg)} mxn`
                : 'Sin estimado',
          },
        ])
        break

      case EHeatMapCategory.RENT:
        setPrices([
          {
            id: 'rentPerM2',
            name: 'Renta por m2',
            value:
              polygon?.rentAvgSqm > 1
                ? `$ ${numberWithCommaWithoutDecimals(polygon.rentAvgSqm)} mxn`
                : 'Sin estimado',
          },
          {
            id: 'averageRent',
            name: 'Promedio renta mensual',
            value:
              polygon?.rentAvg > 1
                ? `$ ${numberWithCommaWithoutDecimals(polygon.rentAvg)} mxn`
                : 'Sin estimado',
          },
        ])
        break

      case EHeatMapCategory.CAPRATE:
        setPrices([
          {
            id: 'caprate',
            name: 'CapRate',
            value: polygon?.caprateIndex
              ? `${numberAsPercentage(polygon.caprateIndex / 100, 1)}`
              : 'Sin estimado',
          },
        ])
        break
    }
  }, [heatMapCategory, polygon])

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      onMouseLeave={onMouseLeave}
      //  <LazyMotion features={domAnimation}>
      //  <m.div
      //     onClick={(event) => event.stopPropagation()}
      //     initial={{
      //       y: '30px',
      //       opacity: 0,
      //     }}
      //     animate={{
      //       y: 0,
      //       opacity: 1,
      //     }}
      //     exit={{
      //       y: '30px',
      //       opacity: 0,
      //     }}
      //     transition={{
      //       type: 'spring',
      //       stiffness: 260,
      //       damping: 20,
      //       duration: 0.5,
      //     }}
      //     onMouseLeave={onMouseLeave}
      //     className="min-w-[358px] p-4 bg-white border border-button-gray-02 rounded-xl [box-shadow:_0px_4px_20px_-4px_rgba(24,26,61,0.16)]"
      // >
      className="min-w-[370px] p-4 bg-white rounded-xl [box-shadow:_0px_4px_20px_-4px_rgba(24,26,61,0.16)]"
    >
      <div className="flex flex-col gap-3">
        <p className="text-body-bold-m text-primary">{name}</p>

        {prices.map((price) => (
          <div
            key={price.id}
            className="w-full grid grid-cols-[auto,max-content] mr-2"
          >
            <div className="flex items-center gap-2.5">
              <div className="p-1 rounded-lg bg-notif-green-01">
                <MdTrendingUp className=" text-notif-green w-5 h-5" />
              </div>
              <p className="text-body-m text-secondary">{price.name}</p>
            </div>

            <p className="text-body-l text-primary">{price.value}</p>
          </div>
        ))}
      </div>

      {/* </m.div>
    </LazyMotion> */}
    </div>
  )
}

export default PolygonPopupContent
